<script setup>
import { ref, onBeforeMount, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import api from "@/api/axios";

const body = document.body;
const store = useStore();

const email = ref("");
const error = ref("");
const success = ref("");
const loading = ref(false);

onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  body.classList.remove("bg-gray-100");
});

onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  body.classList.add("bg-gray-100");
});

const handleSubmit = async () => {
  if (loading.value) return;

  if (!email.value) {
    error.value = "Debes ingresar tu correo";
    return;
  }

  loading.value = true;
  error.value = "";
  success.value = "";

  try {
    const res = await api.post("/forgot-password", { email: email.value });
    success.value =
      res.data?.message ||
      "Si el correo está registrado, recibirás un enlace para restablecer tu contraseña.";
    email.value = "";
  } catch (err) {
    error.value =
      err.response?.data?.error || "No se pudo procesar la solicitud";
  } finally {
    loading.value = false;
  }
};
</script>

<template>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row justify-content-center">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column">
              <div class="card card-plain mt-8">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">¿Olvidaste tu contraseña?</h4>
                  <p class="mb-0">
                    Ingresa el correo asociado a tu cuenta y te enviaremos un
                    enlace para restablecerla.
                  </p>
                </div>

                <div class="card-body">
                  <form @submit.prevent="handleSubmit">
                    <div class="mb-3">
                      <argon-input
                        v-model="email"
                        type="email"
                        placeholder="Correo"
                        size="lg"
                      />
                    </div>

                    <div class="text-center">
                      <argon-button
                        class="mt-2"
                        variant="gradient"
                        color="success"
                        fullWidth
                        size="lg"
                        type="submit"
                        :disabled="loading"
                      >
                        {{ loading ? "Enviando..." : "Enviar enlace" }}
                      </argon-button>
                    </div>

                    <p v-if="success" class="text-success mt-3 text-center">
                      {{ success }}
                    </p>

                    <p v-if="error" class="text-danger mt-3 text-center">
                      {{ error }}
                    </p>
                  </form>
                </div>

                <div class="px-1 pt-0 text-center card-footer px-lg-2">
                  <p class="mx-auto mb-4 text-sm">
                    <router-link
                      to="/signin"
                      class="text-success text-gradient font-weight-bold"
                    >
                      Volver a iniciar sesión
                    </router-link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
